var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBook = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.592 1.152a18 18 0 0 0-2.981-.244c-2.105 0-3.828.366-5.125 1.088C6.968 1.231 5.222.844 3.29.844c-1.681 0-2.866.302-2.915.315L0 1.257l.001 13.906.624-.161c.011-.002 1.12-.283 2.665-.283 1.447 0 2.771.24 3.96.703v.828h2.5v-.856c1.281-.488 2.747-.611 3.86-.611 1.562 0 2.786.225 2.798.227l.592.11V1.229zM1 13.907V2.049a13 13 0 0 1 2.29-.205c1.761 0 3.339.36 4.71 1.044v11.776c-1.403-.617-2.977-.945-4.71-.945-.969 0-1.773.101-2.29.188m15 .031a19 19 0 0 0-2.39-.154c-1.848 0-3.381.298-4.61.855V2.866c1.422-.78 3.271-.958 4.61-.958 1.023 0 1.902.097 2.39.164z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBook);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/book.svg";